module.exports = __webpack_public_path__ + "static/img/Send1.1d6efa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send1.png
// module id = eMdQ
// module chunks = 0